export default __webpack_public_path__ + "static/media/Polygon2.b30186ab.svg";